import getGroupHeaderForSearchTable from './getGroupHeaderForSearchTable';
import getGroupHeaderForSortByDateTime from './getGroupHeaderForSortByDateTime';
import getGroupHeaderForSortBySender from './getGroupHeaderForSortBySender';
import getGroupHeaderForSortBySize from './getGroupHeaderForSortBySize';
import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { shouldTableSortByRenewTime } from 'owa-mail-list-response-processor';
import { mapTableQueryToTableViewOptions } from 'owa-mail-tableview-options';
import { assertNever } from 'owa-assert';
/**
 * Gets the header generator depending on the current settings
 * @param tableView for which to get the header generator
 * @returns GroupHeaderGenerator
 */
export default function getMailListGroupHeaderGenerator(tableView) {
    var headerGenerator = {
        getGroupHeader: null,
        hideFirstHeader: false,
    };
    var headerGeneratorType = mapTableQueryToTableViewOptions(tableView.tableQuery)
        .headerGeneratorType;
    switch (headerGeneratorType) {
        case 'RelevanceHybrid':
            headerGenerator.getGroupHeader = getGroupHeaderForSearchTable;
            break;
        case 'Sender':
            headerGenerator.getGroupHeader = getGroupHeaderForSortBySender;
            break;
        case 'Size':
            headerGenerator.getGroupHeader = getGroupHeaderForSortBySize;
            break;
        case 'DateTime':
            if (!getIsBitSet(2 /* DateHeadersDisabled */)) {
                // hide first header only when table supports pinning
                headerGenerator.hideFirstHeader = shouldTableSortByRenewTime(tableView.tableQuery);
                headerGenerator.getGroupHeader = getGroupHeaderForSortByDateTime;
            }
            break;
        default:
            assertNever(headerGeneratorType);
            break;
    }
    return headerGenerator;
}
//# sourceMappingURL=getMailListGroupHeaderGenerator.js.map